import { combineReducers } from 'redux'

import { membersProfile } from './members'
import { membersDownloadProfile } from './membersDownload'
import { memberTransactionProfile } from './memberTransaction'
import { memberSearchProfile } from './memberSearch'

export const membersReducer = combineReducers({
  membersProfile,
  membersDownloadProfile,
  memberTransactionProfile,
  memberSearchProfile
})
